import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Ask Elfie's panel (P4 §C7.1), opened from anywhere in a workspace: the
 * side menu, ⌘K, or a page asking a question for the reader, as Elfie Pulse
 * does. The panel itself (AnalystDock) asks; this only says what to open with.
 */
export const useAskElfieStore = defineStore('ask-elfie', () => {
  const open = ref(false)
  /** A question to ask as the panel opens; taken once by the panel. */
  const pending = ref<string | null>(null)

  const show = (): void => {
    open.value = true
  }
  const ask = (question: string): void => {
    pending.value = question
    open.value = true
  }
  const take = (): string | null => {
    const question = pending.value
    pending.value = null
    return question
  }

  return { open, pending, show, ask, take }
})
